module.exports = __webpack_public_path__ + "c7a799421112ab71516816245666a5b1.jpg";